import { ISolidMaterial } from "lib/materials";
import { objDataType } from "lib/models/types";
import { CylinderData } from "lib/models/solids/cylinder";
import { cylinderParam } from "../../geometries/solid/cylinder";
import { GraphicProcessor } from "../../graphic-processor";
import { IPoint } from "../../math/types";
import { cadOpType } from "../../operations/factory";
import { createCommand } from "./create-base";

export class CylinderCommand extends createCommand {
  
  public createdData: CylinderData;
  protected opType = cadOpType.CYLINDER;
  protected objType = objDataType.CYLINDER;
  protected param: cylinderParam;
  protected material: ISolidMaterial;

  constructor(
    radius: number,
    height: number,
    basePoint: IPoint,
    rotation: IPoint,
    offset: IPoint,
    scale: IPoint,
    layerId: string,
    graphicProc: GraphicProcessor,
    material: ISolidMaterial
  ) {
    super(layerId, graphicProc);
    this.param = {
      radius,
      height,
      basePoint,
      rotation,
      offset,
      scale,
    };
    this.material = material;
  }
}